// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index/js/" + chunkId + "." + {"127":"78451e72","175":"7598ccaf","201":"cd853d27","242":"9ff09b3a","453":"56fde588","632":"345c3737","905":"93ee3208"}[chunkId] + ".chunk.js";
};